const headline = ['Plus Jakarta Sans', 'Inter', 'sans-serif'].join(',')
const body = ['Inter', 'sans-serif'].join(',')

export const typography = {
  headline,
  body,
  subtitle: body,
  button: body,
  overline: body,
  caption: body,
}
